import React from 'react';
import { get_dynamic_styles } from '../../constant/DynamicStyles';
import ReadingComposer from '../Shared/Composer/ReadingComposer';
import { useSelector } from 'react-redux';
import { layerSelector } from '../../store/feature/layerSlice';
import ReadingComposerTOC from '../Shared/Composer/ReadingComposerWithTOC';

const DocsWithTOC = ({ data, styles }) => {
  const { docs_details } = useSelector(layerSelector);

  return (
    <div
      style={{
        display: styles?.box_styles?.display,
        ...get_dynamic_styles(styles?.box_styles),
      }}
    >
      <ReadingComposerTOC
        contents={docs_details?.content}
        dependents={docs_details?.content}
        mainClass={` prose prose-sm sm:prose lg:prose-lg xl:prose-xl m-0 focus:outline-none   prose-a:text-primary  prose-a:border-0 hover:prose-a:underline prose-img:m-0`}
        styles={styles}
      />
    </div>
  );
};

export default DocsWithTOC;
